import { memo, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import Alert from "@mui/material/Alert";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import { useConnectionStore } from "stores/ConnectionStore";
import { ActionState } from "stores/lib";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const AtlassianConnectRegisterConfigure = memo(
  function JiraSyncRegisterConfigure() {
    const [store, actions] = useConnectionStore();
    const [redirectConnectionID, setRedirectConnectionID] =
      useState<string>("");
    const [search] = useSearchParams();
    const nonce = search.get("nonce");
    const onSuccess = (data: any) => {
      setRedirectConnectionID(data.connection);
    };
    if (store.atlassianConnect.state === ActionState.INITIAL && !!nonce) {
      actions.atlassianConnect({ nonce, onSuccess });
    }
    if (redirectConnectionID) {
      // TODO: when we add another Atlassian Connect integration, switch out URL resolution here.
      return (
        <Navigate
          to={`/environment/destinations/jira/${redirectConnectionID}/notifications`}
        />
      );
    }
    if (!nonce) {
      return (
        <ServiceConnectionStep disabled={false}>
          <Typography>
            <Alert severity="error">
              Could not find the <code>nonce</code> parameter in the URL.
            </Alert>
          </Typography>
        </ServiceConnectionStep>
      );
    }
    if (store.atlassianConnect.state <= ActionState.IN_PROGRESS) {
      return (
        <ServiceConnectionStep disabled={false}>
          <Skeleton variant="rounded" height={320} />
        </ServiceConnectionStep>
      );
    }
    if (store.atlassianConnect.state === ActionState.ERROR) {
      return (
        <ServiceConnectionStep disabled={false}>
          <Alert severity="error">
            There was an error processing the Atlassian Connect nonce.
          </Alert>
        </ServiceConnectionStep>
      );
    }
    return (
      <ServiceConnectionStep disabled={false}>
        <Typography>
          <p>You should be redirected to the configuration page shortly.</p>
        </Typography>
      </ServiceConnectionStep>
    );
  }
);

export default AtlassianConnectRegisterConfigure;
